(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["calculadora-talla-teba-sport-jacket"] && !window.DesignMode) return;
  try {
    
(function() {
  var header = document.querySelector('.collapsible-header');
  var content = document.querySelector('.collapsible-content');
  header.addEventListener('click', function() {
    content.style.display = content.style.display === 'none' || !content.style.display ? 'block' : 'none';
  });

  function cmToInches(cm) {
    return (cm / 2.54).toFixed(1);
  }

  // Inserta aquí tu array de tallas como JSON
  var tallas = [
  { size: "44-XC", shoulders: 42.5, chest: 47.2, waist: 44.0, back: 68.8, sleeve: 59.2 },
  { size: "44-C", shoulders: 42.5, chest: 47.3, waist: 44.1, back: 71.3, sleeve: 61.7 },
  { size: "44", shoulders: 42.5, chest: 47.3, waist: 44.1, back: 73.8, sleeve: 64.2 },
  { size: "44-L", shoulders: 42.5, chest: 47.3, waist: 44.2, back: 76.3, sleeve: 66.7 },
  { size: "45-XC", shoulders: 43.0, chest: 48.2, waist: 45.0, back: 69.1, sleeve: 59.1 },
  { size: "45-C", shoulders: 43.0, chest: 48.3, waist: 45.1, back: 71.6, sleeve: 61.6 },
  { size: "45", shoulders: 43.0, chest: 48.3, waist: 45.1, back: 74.1, sleeve: 64.1 },
  { size: "45-L", shoulders: 43.0, chest: 48.3, waist: 45.2, back: 76.6, sleeve: 66.6 },
  { size: "46-XC", shoulders: 43.5, chest: 49.2, waist: 46.0, back: 69.4, sleeve: 59.0 },
  { size: "46-C", shoulders: 43.5, chest: 49.3, waist: 46.1, back: 71.9, sleeve: 61.5 },
  { size: "46", shoulders: 43.5, chest: 49.3, waist: 46.1, back: 74.4, sleeve: 64.0 },
  { size: "46-L", shoulders: 43.5, chest: 49.4, waist: 46.2, back: 76.9, sleeve: 66.5 },
  { size: "47-XC", shoulders: 43.9, chest: 50.2, waist: 47.0, back: 69.8, sleeve: 58.9 },
  { size: "47-C", shoulders: 43.9, chest: 50.3, waist: 47.1, back: 72.3, sleeve: 61.4 },
  { size: "47", shoulders: 43.9, chest: 50.3, waist: 47.1, back: 74.8, sleeve: 63.9 },
  { size: "47-L", shoulders: 43.9, chest: 50.4, waist: 47.2, back: 77.3, sleeve: 66.4 },
  { size: "48-XC", shoulders: 44.4, chest: 51.2, waist: 48.0, back: 70.1, sleeve: 58.7 },
  { size: "48-C", shoulders: 44.4, chest: 51.3, waist: 48.1, back: 72.6, sleeve: 61.2 },
  { size: "48", shoulders: 44.4, chest: 51.3, waist: 48.1, back: 75.1, sleeve: 63.7 },
  { size: "48-L", shoulders: 44.4, chest: 51.4, waist: 48.2, back: 77.6, sleeve: 66.2 },
  { size: "49-XC", shoulders: 44.9, chest: 52.2, waist: 49.0, back: 70.4, sleeve: 58.6 },
  { size: "49-C", shoulders: 44.9, chest: 52.3, waist: 49.1, back: 72.9, sleeve: 61.1 },
  { size: "49", shoulders: 44.9, chest: 52.3, waist: 49.1, back: 75.4, sleeve: 63.6 },
  { size: "49-L", shoulders: 44.9, chest: 52.4, waist: 49.2, back: 77.9, sleeve: 66.1 },
  { size: "50-XC", shoulders: 45.3, chest: 53.2, waist: 50.0, back: 70.8, sleeve: 58.5 },
  { size: "50-C", shoulders: 45.3, chest: 53.3, waist: 50.1, back: 73.3, sleeve: 61.0 },
  { size: "50", shoulders: 45.3, chest: 53.3, waist: 50.1, back: 75.8, sleeve: 63.5 },
  { size: "50-L", shoulders: 45.3, chest: 53.4, waist: 50.2, back: 78.3, sleeve: 66.0 },
  { size: "51-XC", shoulders: 45.8, chest: 54.2, waist: 51.0, back: 71.1, sleeve: 58.4 },
  { size: "51-C", shoulders: 45.8, chest: 54.3, waist: 51.1, back: 73.6, sleeve: 60.9 },
  { size: "51", shoulders: 45.8, chest: 54.3, waist: 51.1, back: 76.1, sleeve: 63.4 },
  { size: "51-L", shoulders: 45.8, chest: 54.4, waist: 51.2, back: 78.6, sleeve: 65.9 },
  { size: "52-XC", shoulders: 46.3, chest: 55.2, waist: 52.0, back: 71.4, sleeve: 58.3 },
  { size: "52-C", shoulders: 46.3, chest: 55.3, waist: 52.1, back: 73.9, sleeve: 60.8 },
  { size: "52", shoulders: 46.3, chest: 55.3, waist: 52.1, back: 76.4, sleeve: 63.3 },
  { size: "52-L", shoulders: 46.3, chest: 55.4, waist: 52.2, back: 78.9, sleeve: 65.8 },
  { size: "53-XC", shoulders: 46.8, chest: 56.2, waist: 53.0, back: 71.7, sleeve: 58.1 },
  { size: "53-C", shoulders: 46.8, chest: 56.3, waist: 53.1, back: 74.2, sleeve: 60.6 },
  { size: "53", shoulders: 46.8, chest: 56.3, waist: 53.1, back: 76.7, sleeve: 63.1 },
  { size: "53-L", shoulders: 46.8, chest: 56.4, waist: 53.2, back: 79.2, sleeve: 65.6 },
  { size: "54-XC", shoulders: 47.2, chest: 57.2, waist: 54.0, back: 72.1, sleeve: 58.0 },
  { size: "54-C", shoulders: 47.2, chest: 57.3, waist: 54.1, back: 74.6, sleeve: 60.5 },
  { size: "54", shoulders: 47.2, chest: 57.3, waist: 54.1, back: 77.1, sleeve: 63.0 },
  { size: "54-L", shoulders: 47.2, chest: 57.4, waist: 54.2, back: 79.6, sleeve: 65.5 },
  { size: "55-XC", shoulders: 47.7, chest: 58.2, waist: 55.0, back: 72.4, sleeve: 57.9 },
  { size: "55-C", shoulders: 47.7, chest: 58.3, waist: 55.1, back: 74.9, sleeve: 60.4 },
  { size: "55", shoulders: 47.7, chest: 58.3, waist: 55.1, back: 77.4, sleeve: 62.9 },
  { size: "55-L", shoulders: 47.7, chest: 58.4, waist: 55.2, back: 79.9, sleeve: 65.4 }
];

  function calcularDistancia(t, s, c, w, b, m) {
    var base = (Math.abs(t.waist - w) * 4 + Math.abs(t.back - b) * 3 + Math.abs(t.chest - c) * 2 + Math.abs(t.shoulders - s) * 1);
    if (!isNaN(m)) base += Math.abs(t.sleeve - m) * 2;
    return base;
  }

  document.getElementById('sizeForm').addEventListener('submit', function(e) {
    e.preventDefault();
    var shoulders = parseFloat(document.getElementById('shoulders').value);
    var chest = parseFloat(document.getElementById('chest').value);
    var waist = parseFloat(document.getElementById('waist').value);
    var back = parseFloat(document.getElementById('back').value);
    var sleeve = parseFloat(document.getElementById('sleeve').value);

    var distancias = tallas.map(function(t) { return calcularDistancia(t, shoulders, chest, waist, back, sleeve); });
    var maxDistancia = Math.max.apply(null, distancias);

    var resultados = tallas.map(function(t) {
      var distancia = calcularDistancia(t, shoulders, chest, waist, back, sleeve);
      var afinidad = Math.max(0, 100 * (1 - distancia / maxDistancia)).toFixed(1);
      return Object.assign({}, t, { distancia: distancia, afinidad: afinidad });
    }).filter(function(t) { return parseFloat(t.afinidad) >= 70; })
      .sort(function(a, b) { return a.distancia - b.distancia; })
      .slice(0, 2);

    var resultsEl = document.getElementById('results');
    if (resultados.length === 0) {
      resultsEl.innerHTML = '<p style="font-size: 15px; margin-top: 20px; font-weight: 500; color: #b91c1c;">No se encuentra una talla compatible con tus medidas.<br>Por favor, escríbenos a <a href=\"mailto:info@lopezaragon1976.store\">info@lopezaragon1976.store</a> y te ayudaremos personalmente.</p>';
      return;
    }

    var tabla = resultados.map(function(t) {
      return '<tr>' +
        '<td>' + t.size + '</td>' +
        '<td>' + t.shoulders + ' cm (' + cmToInches(t.shoulders) + '")</td>' +
        '<td>' + t.chest + ' cm (' + cmToInches(t.chest) + '")</td>' +
        '<td>' + t.waist + ' cm (' + cmToInches(t.waist) + '")</td>' +
        '<td>' + t.back + ' cm (' + cmToInches(t.back) + '")</td>' +
        '<td>' + t.sleeve + ' cm (' + cmToInches(t.sleeve) + '")</td>' +
        '<td>' + t.afinidad + '%</td>' +
      '</tr>';
    }).join('');

    var advertencia = '';
    if (!isNaN(sleeve)) {
      var fuera = resultados.some(function(t) { return Math.abs(t.sleeve - sleeve) > 1; });
      if (fuera) {
        advertencia = '<p style="font-size: 14px; color: #b91c1c; font-weight: 500; background-color: #fef2f2; padding: 10px; border-radius: 6px; border-left: 4px solid #dc2626; margin-top: 10px;">Aviso: el largo de manga de las tallas sugeridas difiere en más de ±1 cm respecto a tu medida introducida.</p>';
      }
    }

    resultsEl.innerHTML = '<p style="font-size: 15px; margin-top: 20px; font-weight: 500;">Estas son las dos tallas más cercanas a tus medidas / These are the two closest size matches:</p>' +
      '<table style="width: 100%; border-collapse: collapse; margin-top: 12px; font-size: 14px;">' +
        '<thead><tr style="background-color: #f3f4f6;">' +
          '<th style="text-align:left; padding: 8px;">Talla<br><small>Size</small></th>' +
          '<th style="text-align:left; padding: 8px;">Hombros<br><small>Shoulders</small></th>' +
          '<th style="text-align:left; padding: 8px;">Pecho<br><small>Chest (Pit to Pit)</small></th>' +
          '<th style="text-align:left; padding: 8px;">Cintura<br><small>Waist</small></th>' +
          '<th style="text-align:left; padding: 8px;">Espalda<br><small>Back length</small></th>' +
          '<th style="text-align:left; padding: 8px;">L. Manga<br><small>Sleeve</small></th>' +
          '<th style="text-align:left; padding: 8px;">Afinidad<br><small>Match %</small></th>' +
        '</tr></thead><tbody>' + tabla + '</tbody></table>' + advertencia +
      '<p style="font-size: 13px; color: #1e3a8a; font-weight: 500; background-color: #eef2ff; padding: 10px; border-radius: 6px; border-left: 4px solid #1e3a8a; margin-top: 20px;">Debido al tipo de construcción de la chaqueta Teba, se admite una tolerancia de ±1 cm en las medidas clave (hombros, pecho, cintura, espalda y largo de manga) sin comprometer el ajuste óptimo.</p>';
  });
})();

  } catch(e) { console.error(e); }
})();
})();
